import React from 'react';

import { BaseComponent } from "../base/BaseComponent";
import { Form, Col, Button, Spinner, Pagination, Tabs, Tab } from 'react-bootstrap';

//import moment from "moment";
// function getMomentFormatter(format: string): IDateFormatProps {
//     // note that locale argument comes from locale prop and may be undefined
//     return {
//         formatDate: (date) => moment(date).format(format),
//         parseDate: (str) => moment(str, format).toDate(),
//     }
// };
// const dateFormatter = getMomentFormatter("dddd D MMMM YYYY");

interface CalendarEventDetailState {
    fields: { [name: string]: any; };
}

export class CalendarEventDetail extends BaseComponent<{}, CalendarEventDetailState> {
    constructor(props: {}){
        super(props);
        this.state = { fields: {} };
    }
    getValue(field: string) {
        return this.state.fields[field];
    }
    handleOnChange(name: string, value: any) {
        const fields = this.state.fields;
        fields[name] = value;
        this.setState({ fields })
    }
    render() {
        // const [organiser, setOrganiser] = useState();
        return (<div>

<Pagination>
  <Pagination.First />
  <Pagination.Prev />
  <Pagination.Item>{1}</Pagination.Item>
  <Pagination.Ellipsis />

  <Pagination.Item>{10}</Pagination.Item>
  <Pagination.Item>{11}</Pagination.Item>
  <Pagination.Item active>{12}</Pagination.Item>
  <Pagination.Item>{13}</Pagination.Item>
  <Pagination.Item disabled>{14}</Pagination.Item>

  <Pagination.Ellipsis />
  <Pagination.Item>{20}</Pagination.Item>
  <Pagination.Next />
  <Pagination.Last />
</Pagination>

<Tabs defaultActiveKey="profile" id="uncontrolled-tab-example">
  <Tab eventKey="home" title="Home">
    A
  </Tab>
  <Tab eventKey="profile" title="Profile">
    B
  </Tab>
  <Tab eventKey="contact" title="Contact" disabled>
    C
  </Tab>
</Tabs>


    <Spinner animation="border" variant="primary" />
    <Spinner animation="border" variant="secondary" />
    <Spinner animation="border" variant="success" />
    <Spinner animation="border" variant="danger" />
    <Spinner animation="border" variant="warning" />
    <Spinner animation="border" variant="info" />
    <Spinner animation="border" variant="light" />
    <Spinner animation="border" variant="dark" />
    <Spinner animation="grow" variant="primary" />
    <Spinner animation="grow" variant="secondary" />
    <Spinner animation="grow" variant="success" />
    <Spinner animation="grow" variant="danger" />
    <Spinner animation="grow" variant="warning" />
    <Spinner animation="grow" variant="info" />
    <Spinner animation="grow" variant="light" />
    <Spinner animation="grow" variant="dark" />

        <Form>
            <Form.Row>
                <Form.Group as={Col} controlId="formGridEmail">
                <Form.Label>Email</Form.Label>
                <Form.Control type="email" placeholder="Enter email" />
                </Form.Group>

                <Form.Group as={Col} controlId="formGridPassword">
                <Form.Label>Password</Form.Label>
                <Form.Control type="password" placeholder="Password" />
                </Form.Group>
            </Form.Row>

            <Form.Group controlId="formGridAddress1">
                <Form.Label>Address</Form.Label>
                <Form.Control placeholder="1234 Main St" />
            </Form.Group>

            <Form.Group controlId="formGridAddress2">
                <Form.Label>Address 2</Form.Label>
                <Form.Control placeholder="Apartment, studio, or floor" />
            </Form.Group>

            <Form.Row>
                <Form.Group as={Col} controlId="formGridCity">
                <Form.Label>City</Form.Label>
                <Form.Control />
                </Form.Group>

                <Form.Group as={Col} controlId="formGridState">
                <Form.Label>State</Form.Label>
                <Form.Control as="select">
                    <option>Choose...</option>
                    <option>...</option>
                </Form.Control>
                </Form.Group>

                <Form.Group as={Col} controlId="formGridZip">
                <Form.Label>Zip</Form.Label>
                <Form.Control />
                </Form.Group>
            </Form.Row>

            <Form.Group id="formGridCheckbox">
                <Form.Check type="checkbox" label="Check me out" />
            </Form.Group>

            <Button variant="primary" type="submit">
                Submit
            </Button>
        </Form>


            {/* <Label>
                Organiser
                <InputGroup leftIcon="lock" type="text" value={this.getValue('organiser')} placeholder="Organiser" onChange={(e: any) => this.handleOnChange('organiser', e.target.value)} />
            </Label>
            <Label>
                Subject
                <InputGroup leftIcon="lock" type="text" value={this.getValue('subject')} placeholder="Subject" onChange={(e: any) => this.handleOnChange('subject', e.target.value)} />
            </Label>
            <Label>
                All day
                <Switch large checked={this.getValue('allday')} onChange={(e: any) => this.handleOnChange('allday', !this.getValue('allday'))} />
            </Label>

            <Label>
                From date
                <DateInput
                    locale="nl"
                    placeholder={"Select date"}
                    value={this.getValue('fromDate')}
                    onChange={(e: any) => this.handleOnChange('fromDate', e)}
                    {...dateFormatter}
                />
            </Label>

            <Label>
                To date
                <DateInput
                    locale="nl"
                    placeholder={"Select date"}
                    value={this.getValue('toDate')}
                    onChange={(e: any) => this.handleOnChange('toDate', e)}
                    {...dateFormatter}
                />
            </Label> */}
            </div>);
    }
}
